<template>
  <div class="app-main-content">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <fcl-search-bar
        ref="searchBar"
        :show-currency="false"
        :is-manage-module="true"
        :show-schedule="false"
        :is-surcharge="true"
        :filter="filter"
        :show-via="true"
        :is-cp="activeTabName === 'cpList'"
        config-id="SurchargeFCL"
        @onLevelChanged="onLevelChanged"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @reset="resetQuery"
      >
        <template v-if="activeTabName === 'cpList'" slot="operations">
          <el-button v-show="role.editButton" no="onEditCP" type="success" :disabled="!this.cpSelectRow" @click="onEdit_CP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="role.deleteButton" no="onDeleteCP" type="danger" @click="onDelete_CP()">{{ $t('Pricing.Delete') }}</el-button>
        </template>
        <template v-if="activeTabName !== 'cpList'" slot="operations">
          <el-button v-show="role.editButton" no="onEditPP" type="success" :disabled="!this.ppSelectRow" @click="onEdit_PP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="role.deleteButton" no="onDeletePP" type="danger" @click="onDelete_PP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-show="role.approveButton" no="onApprovePP" type="primary" :disabled="!ppSelectLength" @click="onApprove_PP()">{{ $t('Pricing.Approve') }}</el-button>
          <el-button v-show="role.addButton" no="onAddPP" type="primary" @click="onAdd_PP()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-show="role.addButton" no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-show="role.addButton"
            no="saveSurchargeExcelFile"
            :action="URL.price.saveSurchargeExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadExcelSuccess"
            :data="{currentOfficeId:$store.getters.currentOfficeId}"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
      </fcl-search-bar>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.CurrentPrice')" name="cpList">
          <surcharge-fcl-data-grid
            ref="cpList"
            config-module="22080101"
            :row-data="rowCpData"
            :show-approve="true"
            :show-cost="true"
            :show-modify="true"
            :show-create="true"
            :filter="filter"
            :grid-options="cpGridOptions"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.PendingPrice')" name="ppList">
          <surcharge-fcl-data-grid
            ref="ppList"
            config-module="22080102"
            :row-data="rowPpData"
            :show-approve="false"
            :show-modify="true"
            :show-create="true"
            :show-cost="true"
            :filter="filter"
            :grid-options="ppGridOptions"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
      </el-tabs>
      <div style="position: absolute; left: 160px;margin: 10px;">
        <span>{{ globalMsg }}</span>
      </div>
    </div>
    <surcharge-fcl-form
      v-if="surchargeFclFormDialog.visible"
      ref="surchargeFclForm"
      :visible="surchargeFclFormDialog.visible"
      :source-price="surchargeFclFormDialog.sourcePrice"
      :price="surchargeFclFormDialog.price"
      :is-new="surchargeFclFormDialog.isNew"
      :is-cp="this.activeTabName === 'cpList'"
      @close="onsurchargeFclFormDialogClose"
      @deleteCp="deleteCp"
      @clearGrid="clearGrid"
    />
  </div>
</template>

<script>

import FclSearchBar from '@/views/cargo/v0/Price/components/query/fclSearchBar'
import { getLoading } from '@/utils/utilBaseElement'
import { queryEffectiveSurchargeFCL4, queryPendingSurchargeFCL2, deleteSurchargeFCL, approveSurchargeFCLs, checkSurchargeExcel } from '@/api/price/surchargeFcl'
import DateUtils from '@/utils/dateUtils'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import SurchargeFclDataGrid from '@/views/cargo/v0/Price/SurchargeFCL/components/surchargeFclDataGrid'
import SurchargeFclForm from '@/views/cargo/v0/Price/SurchargeFCL/components/surchargeFclForm'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { deepClone } from '@/utils'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'

export default {
  name: 'SurchargeFCL',
  components: {
    SurchargeFclForm,
    SurchargeFclDataGrid,
    FclSearchBar },
  data() {
    return {
      URL,
      activeTabName: 'ppList',
      globalMsg: '', // 查询条数和勾选条数显示
      remarkChange: '',
      targetLevel: 99,
      txtRemarks: '',
      showLevel: false,
      showDetail: false,
      fullscreenLoading: null,
      proxy: {},
      filter: {
        total: 0,
        pol: '',
        pols: '',
        pods: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        saleState: -1,
        txtBookingAgent: '',
        unNo: '',
        contractNo: '',
        level: '',
        currency: '',
        beginDate: null,
        endDate: '',
        createDateFrom: DateUtils.formatStandardDate(new Date()),
        dangerous: false,
        simPol: '',
        isDirect: true,
        isVia: true,
        directTypes: [PriceConstant.UNLIMITED.code, PriceConstant.DIRECT_ONLY.code, PriceConstant.TRANSIT_ONLY.code, PriceConstant.TRANSIT_TO_PORT.code]
      },
      role: {
        addButton: false,
        editButton: false,
        deleteButton: false,
        approveButton: false
      },
      rowCpData: [],
      rowPpData: [],
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.ppSelectLength = rows.length
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      surchargeFclFormDialog: {
        visible: false,
        price: {},
        sourcePrice: {},
        isNew: false
      },
      cpSelectRow: null, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      ppSelectLength: 0, // 待审核的选择数量
      priceFclUtil: null
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    sessionId() {
      return this.$store.getters.token
    },
    isActiveCpTab() {
      return this.activeTabName === 'cpList'
    }
  },
  watch: {
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('SurchargeFCL', val)
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      const activeTab = LocalStorageUtils.getConfiguration('SurchargeFCL')
      this.activeTabName = !StrUtils.isEmpty(activeTab) ? activeTab : 'ppList'
      this.role.addButton = this.$checkPermission(['button_SurchargeFCL_addButton'])
      this.role.editButton = this.$checkPermission(['button_SurchargeFCL_editButton'])
      this.role.deleteButton = this.$checkPermission(['button_SurchargeFCL_deleteButton'])
      this.role.approveButton = this.$checkPermission(['button_SurchargeFCL_approveButton'])
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      this.activeTabName = tab.name
      this.$refs['searchBar'].updateLevel(this.activeTabName === 'cpList')
    },
    onLevelChanged(searchLevel) {
      if (this.activeTabName === 'cpList') {
        this.targetLevel = searchLevel.level
      }
    },
    toAdvancedQuery(data) {
      if (data.hasOwnProperty('pols')) {
        data['pols'] = data['pols'].join(',')
      }
      if (data.hasOwnProperty('pods')) {
        data['pods'] = data['pods'].join(',')
      }
      this.proxy = data
      this.toQuery()
    },
    resetQuery() {
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = null
        this.rowCpData = []
      } else {
        this.ppSelectRow = null
        this.rowPpData = []
      }
      this.globalMsg = ''
    },
    // 查询
    toSimpleQuery(proxy) {
      this.proxy = proxy
      this.toQuery(false)
    },
    onsurchargeFclFormDialogClose() {
      this.surchargeFclFormDialog.visible = false
      this.surchargeFclFormDialog.data = {}
    },
    toQuery(isAdvancedQuery = true) {
      this.fullscreenLoading = getLoading()
      if (this.activeTabName === 'cpList') {
        queryEffectiveSurchargeFCL4(this.proxy).then((res) => {
          this.loadingEnd()
          this.rowCpData = this.loadMore(res.data)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      } else {
        queryPendingSurchargeFCL2(this.proxy).then((res) => {
          this.loadingEnd()
          this.rowPpData = this.loadMore(res.data)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    loadMore(_resMap) {
      if (_resMap && _resMap.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), 0)
        return []
      }
      const count = _resMap.length
      // 只返回部分结果的话，弹窗提醒是否加载更多
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toQuery()
          return
        })
      }
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        _resMap.pop()
      }
      this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), _resMap.length)
      return _resMap
    },
    onRowDoubleClicked(e) {
      const data = e.data
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = data
        this.onEdit_CP()
      } else {
        this.ppSelectRow = data
        this.onEdit_PP()
      }
    },
    loadingEnd() {
      const api = this.getGridOptionsApi()
      api.clearFocusedCell()
      api.refreshCells({ force: true })
      if (this.isActiveCpTab) {
        this.$refs['cpList'].txtRemarks = ''
      } else {
        this.$refs['ppList'].txtRemarks = ''
        this.ppSelectLength = 0
      }
      this.cpSelectRow = null
      this.ppSelectRow = null
      this.fullscreenLoading.close()
    },
    getGridOptionsApi() {
      return this.isActiveCpTab ? this.cpGridOptions.api : this.ppGridOptions.api
    },
    onEdit_CP() {
      const newPrice = deepClone(this.cpSelectRow)
      delete newPrice['uuid']
      delete newPrice['dateCreated']
      delete newPrice['externalId']
      delete newPrice['externalRefNo']
      this.edit(newPrice)
    },
    onDelete_CP() {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecord'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.deleteCp(uuids)
      })
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      const { api } = this.cpGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      for (const item of selectedRows) {
        if (item.branchId !== this.$store.getters.currentOfficeId) {
          this.$message.warning(this.$t('Pricing.pleaseChooseOtherOfficeData'))
          return null
        }
      }
      return selectedRows
    },
    // 获取待审核的勾选数据
    getSelectedRowsPp() {
      const { api } = this.ppGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    // 修改已发布运价后, 移除原有记录
    deleteCp(data) {
      deleteSurchargeFCL(data).then(res => {
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
        this.toQuery()
      }).finally(() => {
      })
    },
    onEdit_PP() {
      this.edit(this.ppSelectRow)
    },
    edit(selectRow) {
      if (!this.role.editButton) return
      if (!selectRow) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.surchargeFclFormDialog.visible = true
      this.surchargeFclFormDialog.isNew = false
      this.surchargeFclFormDialog.price = deepClone(selectRow)
      this.surchargeFclFormDialog.sourcePrice = selectRow
    },
    onDelete_PP() {
      const selectedRows = this.getSelectedRowsPp()
      for (const item of selectedRows) {
        if (!(this.role.deleteButton || item.createdBy === this.$store.getters.userInfo.userId)) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecords'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        deleteSurchargeFCL(uuids).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.toQuery()
        })
      })
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    // 审核
    onApprove_PP() {
      const selectedRows = this.getSelectedRowsPp()
      if (selectedRows === null) return
      this.$confirm(this.$t('Pricing.IsApproveRecords'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        approveSurchargeFCLs(selectedRows).then(res => {
          this.$message.success(this.$t('Message.AuditSuccessfully'))
          this.ppGridOptions.api.updateRowData({ 'remove': selectedRows })
        })
      })
    },
    onAdd_PP() {
      this.surchargeFclFormDialog.visible = true
      this.surchargeFclFormDialog.isNew = true
      this.surchargeFclFormDialog.price = {
        freightType: 2,
        state: PriceConstant.PRICE_STATE_PENDING,
        currency: 'USD',
        direct: true,
        directType: PriceConstant.UNLIMITED.code,
        eqType: 'GP',
        cost20: 0,
        sum20: 0,
        cost40: 0,
        sum40: 0,
        costhc: 0,
        sumhc: 0,
        cost45: 0,
        sum45: 0,
        cost20nor: 0,
        cost40nor: 0,
        sum20nor: 0,
        sum40nor: 0,
        costCasePrice: 0,
        casePrice: 0,
        dangerousClass: [],
        generateCharge: true
      }
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('FCL_Surcharge_sample.xls', 'price')
    },
    selectRowChange(data) {
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
    },
    onTxtRemarksDoubleClick() {
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
        return false
      }
      return new Promise((resolve, reject) => {
        this.checkExcel(file).then(result => {
          if (StrUtils.isEmpty(result)) {
            resolve()
            return
          }
          this.$confirm(result, this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            resolve()
            // 定位到该列
          }).catch(() => {
            reject()
          })
        })
      })
    },
    async checkExcel(file) {
      let result = ''
      await checkSurchargeExcel(file).then(res => {
        result = res.data
      })
      return result
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        if (result === '') {
          this.$message.error(this.$t('Pricing.NoRecordUpload'))
          return
        }
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          const tmp = result.split(':')
          msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
          msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        }
        return false
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      this.$confirm(failResult.replace(/\n\t/g, '<br/>'), this.$t('Message.Error2'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('common.btn.ok'),
        type: 'error'
      }).then(() => {
        // 定位到该列
      }).catch(() => {
      })
    },
    clearGrid() {
      if (!this.isActiveCpTab) {
        this.loadingEnd()
      }
    }
  }
}
</script>

<style scoped>

</style>
